/**
 * 提交/批准
 */
export const REQUEST_APPROVAL = "viewtype_approve";

/**
 * 提交到退回节点
 */
export const REQUEST_SUBMIT_BACK_NODE = "viewtype_submitbacknode";

/**
 *  保存
 */
export const REQUEST_SAVE = "viewtype_save";

/**
 *  转发
 */
export const REQUEST_FORWARD = "viewtype_forward";

/**
 * 转发接收人批注
 */
export const REQUEST_POSTIL = "viewtype_postil";

/**
 *  转办
 */
export const REQUEST_HANDLE_FORWARD = "view_handleForward";

/**
 *  意见征询
 */
export const REQUEST_TAKING_OPINIONS = "view_takingOpinions";

/**
 *  意见征询批注
 */
export const REQUEST_TPOSTIL = "viewtype_tpostil";

/**
 *  抄送接收人批注
 */
export const REQUEST_RPOSTIL = "viewtype_rpostil";

/**
 *  退回
 */
export const REQUEST_REJECT = "viewtype_reject";


// WEBPACK FOOTER //
// ../src4js/pc4mobx/workflowForm/constants/requestActions.js